import { CardMedia as BaseCardMedia } from '@mui/material';
import useLoadedImage from 'hooks/useLoadedImage';
import React from 'react';

function CardMedia({
  image,
  loading = false,
  ...props
}) {
  const cover = useLoadedImage(image);
  return (
    <BaseCardMedia
      data-has-skeleton
      {...props}
      sx={{
        overflow: 'hidden',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: (theme) => theme.spacing(0.5),
        transition: 'opacity 0.5s ease',
        opacity: cover.isLoaded ? 1 : 0.2,
        flexShrink: 0,
        ...props.sx,
      }}
      image={!loading ? cover.image : null}
    />
  );
}

export default CardMedia;
